import { z } from "zod";

export const ProgramType = z.enum(["BidNet", "BidGross"]);

export type ProgramTypeEnum = z.infer<typeof ProgramType>;

export const ProgramTypeDisplayName: Record<ProgramTypeEnum, string> = {
  [ProgramType.enum.BidNet]: "Bid Net",
  [ProgramType.enum.BidGross]: "Gross Bid",
};
